import React from 'react';

import { ButtonPriority, ButtonSize, PaddingModes } from 'wix-ui-tpa';
import { Button } from 'wix-ui-tpa/cssVars';

import { st, classes } from './WidgetButton.st.css';

export const enum WidgetButtonPriority {
  basic = ButtonPriority.basic,
  primary = ButtonPriority.primary,
  secondary = ButtonPriority.secondary,
  basicSecondary = ButtonPriority.basicSecondary,
}

export const toButtonPriority = (
  priority: WidgetButtonPriority,
): ButtonPriority => {
  return priority === WidgetButtonPriority.primary
    ? ButtonPriority.primary
    : ButtonPriority.secondary;
};
export const enum WidgetButtonSize {
  medium = ButtonSize.medium,
  small = ButtonSize.small,
}

export const toButtonSize = (
  size: WidgetButtonSize,
): undefined | ButtonSize => {
  switch (size) {
    case WidgetButtonSize.medium:
      return ButtonSize.medium;
    case WidgetButtonSize.small:
      return ButtonSize.small;
  }
};

export const WidgetButton: React.FC<{
  text: string;
  title?: string;
  onClick: () => void;
  priority?: WidgetButtonPriority;
  fullWidth?: boolean;
  size?: WidgetButtonSize;
  paddingMode?: PaddingModes;
  disabled?: boolean;
  selected?: boolean;
  id?: string;
  ariaLabelledBy?: string;
}> = ({
  text,
  title = text,
  onClick,
  priority = WidgetButtonPriority.primary,
  fullWidth = false,
  size = WidgetButtonSize.medium,
  paddingMode,
  disabled,
  selected,
  id,
  ariaLabelledBy,
}) => {
  return (
    <Button
      id={id}
      aria-labelledby={ariaLabelledBy}
      className={st(classes.root, {
        priority,
        size,
        fullWidth,
        disabled,
        selected,
      })}
      title={title}
      onClick={onClick}
      paddingMode={paddingMode}
      priority={toButtonPriority(priority)}
      fullWidth={fullWidth}
      size={toButtonSize(size)}
      wrapContent
      disabled={disabled}
    >
      {text}
    </Button>
  );
};
